<template>
    <div class="process-section pt-100 pb-70" style="background: white;">
        <div class="container">
            <div class="section-title section-title-lg">
                <small>{{ $t('home.process.subtitle') }}</small>
                <h2>{{ $t('home.process.title') }}</h2>
            </div>
            <div class="process-content">
                <div class="row justify-content-center">
                    <div
                        class="col-sm-6 col-lg-4 pb-30"
                        v-for="(item, index) in processItems"
                        :key="item.title"
                    >
                        <div class="process-item process-item-center border">
                            <div class="process-thumb">
                                <img v-lazy="processImage(item.image)" :class="thumbClasses[index]" :alt="item.alt || item.title">
                            </div>
                            <div class="process-text">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Process',
    computed: {
        processItems() {
            const data = this.$t('home.process.items')
            return Array.isArray(data) ? data : []
        },
        thumbClasses() {
            return ['one', 'two', 'three']
        }
    },
    methods: {
        processImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        }
    }
}
</script>

<style scoped>
.process-item {
    box-shadow: 0 4px 16.6px rgba(122, 151, 177, 0.25);
    height: 100%;
    display: flex;
    flex-direction: column;
}

.process-thumb {
    width: 102px;
    height: 102px;
    margin: 0;
}

/* .process-thumb img {
    width: 100%;
    height: 100%;
    object-fit: contain;
} */


.process-text {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.process-text h3 {
    margin-bottom: 10px;
}

.process-text p {
    line-height: 150%;
    flex: 1;
}
.one {
    width: 117.128px;
    height: 106.825px;
    top: -10px;
}
.two {
    width: 113px;
    height: 102px;
    top: -12px;
}
.three {
    width: 106.449px;
    height: 97.086px;
    top: -5px;
}
</style>
